import { AnnotationModalComponent } from './components/annotation/annotation-modal.component';
import { BaseModalComponent } from './components/base/base-modal.component';
import { ModalService } from './services/modal.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NameComponent } from './components/name/name.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AddressComponent } from './components/address/address.component';
import { TelecomAddComponent } from './components/telecom-add/telecom-add.component';
import { ContactComponent } from './components/contact/contact.component';
import { ContactInfoComponent } from './components/contact-info/contact-info.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { GenderComponent } from './components/gender/gender.component';
import { ProfessionalDataComponent } from './components/professional-data/professional-data.component';

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        NameComponent,
        AddressComponent,
        TelecomAddComponent,
        ContactComponent,
        GenderComponent,
        ContactInfoComponent,
        ProfessionalDataComponent,
        BaseModalComponent,
        AnnotationModalComponent
    ],
    imports: [
        CommonModule, IonicModule,
        FormsModule, ReactiveFormsModule,
        TranslateModule
    ],
    providers: [ModalService],
    entryComponents: [
        NameComponent,
        AddressComponent,
        TelecomAddComponent,
        ContactInfoComponent,
        ContactComponent,
        GenderComponent,
        ProfessionalDataComponent,
        AnnotationModalComponent
    ],
    exports: [HeaderComponent, FooterComponent, BaseModalComponent]
})
export class ModalsModule { }
